module.exports = __webpack_public_path__ + "f24071a8577891ac8365056fb0dac7bb.jpg";